const multi = () => import("@/pages/dp/multi/multi");
const single = () => import("@/pages/dp/single/single");
const target = () => import("@/pages/dp/target/target");

export default [
  {
    path: "/dp/target",
    name: "target",
    component: target,
    meta: {
      title: "指标配置",
      noCache: true,
      affix: true,
      path: ["大屏指标配置", "指标配置"]
    }
  },
  {
    path: "/dp/multi",
    name: "multi",
    component: multi,
    meta: {
      title: "企业年月维度", 
      noCache: true,
      affix: true,
      path: ["大屏指标配置", "企业年月维度"]
    }
  },
  {
    path: "/dp/single",
    name: "single",
    component: single,
    meta: {
      title: "单指标",
      noCache: true,
      affix: true,
      path: ["大屏指标配置", "单指标"]
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/dpInfo.js